<template>
    <section class="fullwidth">
        <div class="section-block">
            <v-row>
                <v-col class="col-12 col-md-4">
                    <div class=" group-header">{{ title }}</div>
                </v-col>
            </v-row>
            <div class="grid">           
                <div v-for="(proj, i) in projects" :key="i" class="proj">
                    <a v-if="proj.link" :href="proj.link.url" target="_blank">
                    <div class="proj-header">
                        <div style="width: 100%; display: flex; justify-content: space-between">
                            <div>
                                <h1>
                                    <a v-if="proj.link" :href="proj.link.url" target="_blank">{{ proj.title }}</a>
                                    <router-link v-else-if="proj.route" :to="proj.route.url">{{ proj.title }}</router-link>
                                    <span v-else>{{ proj.title }}</span>
                                </h1>
                                <h3>
                                    {{ proj.subtitle }}
                                </h3>
                            </div>

                            <div class="logo">
                                <img :src="proj.icon" alt="">
                            </div>
                        </div>
                        <div
                            v-if="proj.body"
                            class="section-body">
                            <p v-for="(line, i) in proj.body.split('\n')" :key="i" v-html="line"/>
                        </div>
                    </div>
                    </a>

                    <router-link v-else-if="proj.route" :to="proj.route.url">
                    <div class="proj-header">
                        <div style="width: 100%; display: flex; justify-content: space-between">
                            <div>
                                <h1>
                                    <a v-if="proj.link" :href="proj.link.url" target="_blank">{{ proj.title }}</a>
                                    <router-link v-else-if="proj.route" :to="proj.route.url">{{ proj.title }}</router-link>
                                    <span v-else>{{ proj.title }}</span>
                                </h1>
                                <h3>
                                    {{ proj.subtitle }}
                                </h3>
                            </div>

                            <div class="logo">
                                <img :src="proj.icon" alt="">
                            </div>
                        </div>
                        <div
                            v-if="proj.body"
                            class="section-body">
                            <p v-for="(line, i) in proj.body.split('\n')" :key="i" v-html="line"/>
                        </div>
                    </div>
                    </router-link>
                    
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: [
        'projects', 'title'
    ],
    data: () => ({
    }),
};
</script>
<style scoped>
.fullwidth {
    width: 100%;
    margin: 0 0 72px;
    /* background-color: hsl(0, 0%, 97%); */
}
.proj {
    padding-left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    padding: 18px;
    margin: -18px;
    /* padding: 18px;
    margin: -18px;
    border: 1 solid var(--text-color);  
    box-sizing: border-box; */
}
.proj:hover {
    /* padding: 22px;
    margin: -26px; */
    /* padding: 22px; */
    /* margin: -22px;
    border: 4px solid var(--text-color); */
    background-color: rgba(144, 144, 144, 0.05);
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0, 0.4, 0.5, 1);
}
.proj>a {
    border-bottom: none;
}
.project-data {
    margin-top: 40px;
}
.proj-header {
    display: flex;
    flex-direction: column;
}
.proj-header>*:first-child, .section-title {
    margin-bottom: 18px;
}
.v-expansion-panel {
  box-shadow: 0;
}
.status-block {
    margin-top: 60px;
}
.section-title {
    font-family: Roboto Mono;
    text-transform: uppercase;
    line-height: 120%;
    font-size: 32px;
    letter-spacing: 0.15em;
    flex-basis: inherit;
    padding-bottom: 8px;
}
.section-title.md {
    font-size: 36px;
}
.section-subtitle {
    font-style: italic;
    font-family: Roboto Mono;
    letter-spacing: 0.1em;
    font-size: 16px;
}
.logo {
    margin-left: 8px;
}
.logo img {
    height: 32px;
}
.section-block .section-line {
    border-top: solid 1px #2B2B2B;
    width: 60px;
    height: 20px;
    margin: 20px 0;
    flex-basis: inherit;
}
.section-block .section-body {
    line-height: 170%;
}
.section-buttons {
    margin-top: 16px;
    display: flex;
    align-items: flex-start;
}
.v-application .proj-body > p {
    margin-bottom: 12px;
}
</style>